interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "TWD";
};

const TWD: Currency = Object.freeze({
  "displayName": "New Taiwan Dollar",
  "numericCode": 901,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "before",
  "isoCode": "TWD",
  "symbol": "$"
});

export { TWD };
